// UserCommissionRecord.js

import React from "react";
import { useNavigate } from "react-router-dom";

import "./Record.css";

const UserCommissionRecord = () => {
  const navigate = useNavigate();

  return (
    <div className="user-commission-record">

      {/* =========================
          BACK BUTTON
      ========================= */}
      <button
        type="button"
        className="record-back-button"
        onClick={() => navigate(-1)}
      >
        <span className="back-icon">←</span>
        <span>Back</span>
      </button>


      {/* =========================
          HEADER
      ========================= */}
      <div className="user-commission-header">

        <div>

          <span>
            USER RECORD
          </span>

          <h1>
            Commission & Bonus
          </h1>

          <p>
            View your commission and bonus
            records in one place.
          </p>

        </div>

      </div>


      {/* =========================
          MENU
      ========================= */}
      <div className="commission-record-menu">

        {/* COMMISSION */}
        <button
          type="button"
          className="record-menu-card commission-menu"
          onClick={() =>
            navigate("/user-commission-record")
          }
        >

          <div className="record-menu-icon">
            💰
          </div>

          <div className="record-menu-content">

            <span>
              COMMISSION
            </span>

            <h2>
              Commission Record
            </h2>

            <p>
              View your referral commissions,
              amount, date and payment status.
            </p>

          </div>

          <div className="record-menu-arrow">
            →
          </div>

        </button>


        {/* BONUS HISTORY */}
        <button
          type="button"
          className="record-menu-card bonus-menu"
          onClick={() =>
            navigate("/Bonus-History")
          }
        >

          <div className="record-menu-icon">
            🎁
          </div>

          <div className="record-menu-content">

            <span>
              BONUS
            </span>

            <h2>
              Bonus History
            </h2>

            <p>
              View all your previous bonus
              transactions and payment records.
            </p>

          </div>

          <div className="record-menu-arrow">
            →
          </div>

        </button>


        {/* MONTHLY BONUS */}
        <button
          type="button"
          className="record-menu-card monthly-menu"
          onClick={() =>
            navigate("/UserMonthly-BonusHistory")
          }
        >

          <div className="record-menu-icon">
            📅
          </div>

          <div className="record-menu-content">

            <span>
              MONTHLY
            </span>

            <h2>
              Monthly Bonus
            </h2>

            <p>
              Check your monthly bonus,
              earnings and payment history.
            </p>

          </div>

          <div className="record-menu-arrow">
            →
          </div>

        </button>

      </div>

    </div>
  );
};

export default UserCommissionRecord;
